import React, { Component } from 'react';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import { MENU_HEIGHT } from '../../index';

import './Menu.css';
import { trackInnerTextClick } from '../../utils';

class Menu extends Component {
  render() {
    return (
      <div
        className="lp-desktop-menu-container"
        style={{
          height: this.props.height,
        }}
      >
        <div className="lp-desktop-menu-core">
          <AnchorLink className="lp-logo" href="#lp-header" onClick={e => {
            trackInnerTextClick(e, 'a menu item from the desktop menu');
          }}>
            <div>ImproveOSM<span>.org</span></div>
          </AnchorLink>
          <div className="lp-items">
            <AnchorLink offset={MENU_HEIGHT} href="#lp-josm" onClick={e => {
              trackInnerTextClick(e, 'a menu item from the desktop menu');
            }}>
              <div>JOSM</div>
            </AnchorLink>
            <AnchorLink offset={MENU_HEIGHT} href="#lp-tools" onClick={e => {
              trackInnerTextClick(e, 'a menu item from the desktop menu');
            }}>
              <div>TOOLS</div>
            </AnchorLink>
            <AnchorLink offset={MENU_HEIGHT} href="#lp-data-dumps" onClick={e => {
              trackInnerTextClick(e, 'a menu item from the desktop menu');
            }}>
              <div>DATA DUMPS</div>
            </AnchorLink>
            {/* <AnchorLink offset={MENU_HEIGHT} href="#lp-ai" onClick={e => {
              trackInnerTextClick(e, 'a menu item from the desktop menu');
            }}>
              <div>AI</div>
            </AnchorLink> */}
          </div>
        </div>
      </div>
    );
  }
}

export default Menu;



// WEBPACK FOOTER //
// ./src/components/desktop/Menu.js